export default __webpack_public_path__ + "static/ellipse-glow-8f0466546da0e7be4dae2cc46cee1061.png";